import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import AddReviewContainer from "Containers/AddReviewContainer";
import WhatsappSendMessageContainer from "Containers/WhatsApp/WhatsappSendMessageContainer";
import { ModalLayout } from "ComponentsUI/Modallayout";
import { isMainSiteCode } from "Utils/siteConfig";

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class Page extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			counter: null,
		};
		let fixedModel = props.ApplicationModel.fixedPanelModel;
		fixedModel.hideFixedPanel();
	}

	componentWillUnmount() {
		// let searcheModel = this.props.ApplicationModel.searcheModel;
		let fixedModel = this.props.ApplicationModel.fixedPanelModel;
		//searcheModel.resetData();
		fixedModel.showFixedPanel();
	}

	calculateBackUrl() {
		let url = this.props.ApplicationModel.commonViewModel.previousPath;
		if (!url || url.includes("/select-region?")) {
			url = generateUrl(Routes.Default.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
		}
		return url;
	}

	toBack() {
		this.props.history.push(this.calculateBackUrl());
	}

	render() {
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		const siteCode = this.props.ApplicationModel.siteCode;

		return (
			<>
				{isMainSiteCode(siteCode) && <div></div>}
				<WhatsappSendMessageContainer
					whatsappType="feedback"
					whatsappSettings={this.props.ApplicationModel.siteConfig.settings.whatsapp_send_message}
				/>
				<ModalLayout withoutClose={true}>
					<AddReviewContainer
						h1={this.props.h1}
						closeHandler={() => this.toBack()}
						match={this.props.match}
						ApplicationModel={this.props.ApplicationModel}
						windowSizes={windowSizes}
						url={this.calculateBackUrl()}
					/>
				</ModalLayout>
			</>
		);
	}
}
